import * as CONFIG from './config';


exports.getAgendaItem = function (id) {
    // console.log("getAgendaItem==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/agenda/agendaDetails' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.getAgendaItemList = function (id) {
    // console.log("getAgendaItemList==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/agenda/all' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.addAgendaItem = function (objModel) {
    // console.log("addAgendaItem==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/agenda/create', objModel)
            .then(function (response) {
                // console.log('addAgendaItem succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addAgendaItem err==>',err);
                reject(err);
            });
    });
}

exports.updateAgendaItem = function (objModel) {
    // console.log("updateAgendaItem==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/agenda/update', objModel)
            .then(function (response) {
                // console.log('updateAgendaItem succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateAgendaItem err==>',err);
                reject(err);
            });
    });
}

exports.updateNotes = function (objModel) {
    // console.log("updateAgendaItem==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/agenda/updateNote', objModel)
            .then(function (response) {
                // console.log('updateAgendaItem succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateAgendaItem err==>',err);
                reject(err);
            });
    });
}

exports.updateFile = function (id, objModel) {
    // console.log("updateFile==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpPostFile('/agenda/updateExistingFile' + param, objModel)
            .then(function (response) {
                // console.log('updateFile succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateFile err==>',err);
                reject(err);
            });
    });
}

exports.deleteFile = function (id) {
    // console.log("updateFile==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpPost('/agenda/deleteAgendaFile' + param)
            .then(function (response) {
                // console.log('updateFile succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateFile err==>',err);
                reject(err);
            });
    });
}

exports.deleteAgendaItem = function (id) {
    // console.log("updateFile==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpPost('/agenda/deleteAgenda' + param)
            .then(function (response) {
                // console.log('updateFile succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateFile err==>',err);
                reject(err);
            });
    });
}


exports.updateFileOrder = function (file_id, order_number, oldIndex, meeting_id) {
    // console.log("rejectUser==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/agenda/updateAgendaFileOrder/' + file_id + '/' + order_number + '/' + oldIndex + '/' + meeting_id)
            .then(function (response) {
                // console.log('rejectUser succ==>', response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('rejectUser err==>', err);
                reject(err);
            });
    });
}


// WEBPACK FOOTER //
// ./api/agendaitemdetails.js